<template>
  <data-list
    ref="dataList"
    class="content md"
    :url="`${url}/tablet-list`"
    query="&sort=-id&expand=tabletStatus,tabletBlock.tabletRegion"
    entity-name="龛位"
    add-btn=""
    hide-show-detail
    hide-edit
    hide-delete
    :columns="columns"
    :search-key-type="searchKeyType"
    :action="action"
    :request-config="{ noTempleFilter: true }"
    :default-query="defaultQuery"
  >
    <template v-slot:button>
      <a-button type="primary" @click="goOverview">龛位总览</a-button>
    </template>
    <template v-slot:query="{ form }">
      <a-form-model-item label="所属区域">
        <a-select
          style="width: 180px"
          placeholder="选择区域查询"
          allow-clear
          @change="regionChange($event, form)"
          :options="regionList"
          v-model="form.mem_tablet_region_id"
        >
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="所属区块">
        <a-select
          style="width: 180px"
          placeholder="选择区块查询"
          allow-clear
          @change="updateList"
          :options="blockList"
          v-model="form.mem_tablet_block_id"
        >
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="龛位编号">
        <a-input
          v-model="form.num"
          placeholder="输入龛位编号查询"
          allow-clear
        ></a-input>
      </a-form-model-item>
      <a-form-model-item label="供奉状态">
        <a-select
          style="width: 180px"
          placeholder="选择供奉状态"
          allow-clear
          @change="updateList"
          :options="worshipStatusOptions"
          v-model="form.memorial_status"
        >
        </a-select>
      </a-form-model-item>
    </template>
    <template v-slot:action="{ item, index }">
      <a class="txt-btn" @click.stop="goDetail(item, index)">查看订单</a>
    </template>
  </data-list>
</template>

<script>
import { worshipStatusOptions } from "../../common/tablet/type";

export default {
  name: "TabletNiche",
  data() {
    return {
      url: "/admin/memorial-tablet-block-item",
      columns: [
        {
          title: "所属区域",
          customRender: (text) => {
            return <span>{text?.tabletBlock?.tabletRegion?.name}</span>;
          },
        },
        {
          title: "所在区块",
          dataIndex: "tabletBlock",
          customRender: (text) => {
            return <span>{text?.name}</span>;
          },
        },
        { title: "龛位编号", dataIndex: "num" },
        {
          title: "龛位价格",
          customRender: (text) => {
            return <span>￥{text?.tabletBlock?.price}</span>;
          },
        },
        {
          title: "供奉状态",
          dataIndex: "tabletStatus",
          customRender: (text) => (
            <a-tag color={text ? "green" : ""}>
              {text ? "已供奉" : "未供奉"}
            </a-tag>
          ),
        },
        {
          title: "是否开放",
          customRender: (record) => {
            return (
              <a-switch
                checked={record.is_open == 1}
                onChange={($event) => this.onChange($event, record)}
              ></a-switch>
            );
          },
        },
      ],
      searchKeyType: {
        mem_tablet_region_id: 2,
        mem_tablet_block_id: 2,
        num: 2,
        memorial_status: 2,
      },
      regionList: [],
      blockList: [],
      worshipStatusOptions,
    };
  },
  computed: {
    action() {
      return this.$route.meta.action;
    },
    dataList() {
      return this.$refs.dataList;
    },
    defaultQuery() {
      const status = this.$route.query.status;
      if (status) {
        return { memorial_status: status * 1 };
      } else {
        return undefined;
      }
    },
  },
  created() {
    this.getRegion();
  },
  methods: {
    getRegion() {
      this.$axios({
        url: "/admin/memorial-tablet-region",
        method: "GET",
        params: {
          pageSize: 9999,
        },
        noTempleFilter: true,
      }).then((res) => {
        this.regionList = res.data?.map((item) => {
          item.key = item.id;
          item.title = item.name;
          return item;
        });
      });
    },
    regionChange(val, form) {
      form.mem_tablet_block_id = undefined;
      this.getBlock();
      this.updateList();
    },
    getBlock() {
      this.$axios({
        url: "/admin/memorial-tablet-block",
        method: "GET",
        params: {
          pageSize: 9999,
        },
        noTempleFilter: true,
      }).then((res) => {
        this.blockList = res.data?.map((item) => {
          item.key = item.id;
          item.title = item.name;
          return item;
        });
      });
    },
    onChange(checked, record) {
      let text = checked ? "开放" : "关闭";
      this.$confirm({
        title: "提示",
        content: `确定${text}此龛位吗？`,
        onOk: () => {
          this.$axios({
            url: `${this.url}/${record.id}`,
            method: "PATCH",
            data: {
              is_open: checked ? 1 : 2,
            },
          }).then((res) => {
            record.is_open = res.is_open;
            this.$message.success(text + "成功");
          });
        },
      });
    },
    updateList() {
      this.dataList.updateList();
    },
    goOverview() {
      this.$router.push({ name: "TabletNicheOverview" });
    },
    goDetail(item) {
      this.$router.push({ name: "TabletNicheDetail", params: { id: item.id } });
    },
  },
};
</script>

<style lang="less" scoped>
.tip-msg {
  color: grey;
}
.unit {
  margin-left: 12px;
}
</style>
